import React, { Component } from 'react';

class SuggestionsList extends Component {
    render() {
        const {suggestions = [], keys = [], action, styles = {}, rect = { top: 0, left: 0 }} = this.props
        let suggestionStyles = { left: rect.left, top: rect.bottom, ...styles};

        return (
            <div className="suggestionsComponent" style={suggestionStyles}>
                <ul className="suggestionsList" key="suggestionsList">
                    {suggestions.map((suggestion, index) =>
                        <li className="suggestion" onMouseDown={() => { action(suggestion) }} key={`suggestionOption-${index}`}>
                            <div className="d-flex">
                                {keys.map((key) => <span className={key.classes} style={key.styles} key={`suggestionOption-${index}-${key.field}`}>{suggestion[key.field]}</span>)}
                            </div>
                        </li>
                    )}
                </ul>
            </div>
        )
    }
}

export default SuggestionsList;